import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';


const activeClassName = 'is-active';
export const StyledNavItem = styled(NavLink).attrs({
    activeClassName
})`
    border: 1px solid #8B8B8B;
    display:block;
    text-decoration:none;
    padding-left:5px;
    padding-right:5px;
    padding-top:5px;
    padding-bottom:5px;
    display:flex;
    align-items:center;
    justify-content:center;
    color:#8B8B8B;
    font-weight:bold;
    &:hover {
        background-color: #047961;
        color:#fff;
    }

    font-size:0.75rem;

    cursor:pointer;
    width: calc(100% / 4 - 5px);
    text-align:center;  

    &.is-active {
        background-color: #047961;
        color:#fff;
    } 
`;
